'use client';
import 'devextreme/dist/css/dx.light.css';

import { licenseKey } from '@/devextreme-license';
import config from 'devextreme/core/config';
import { locale } from 'devextreme/localization';
import { useParams } from 'next/navigation';

// Run once on the client to register the license
config({ licenseKey: licenseKey });

function DevexInit() {
  const params = useParams<{ locale?: string }>();
  const appLocale = params?.locale;

  // Keep DevExtreme's own locale (number/date parsing & formatting, e.g. decimal vs.
  // thousands separators) in sync with the app's active react-intl locale, otherwise
  // widgets like NumberBox always assume en-US separator conventions. This must run
  // synchronously during render (not in an effect) so it's applied before any
  // DevExtreme widgets mount and format their initial values.
  if (appLocale) {
    locale(appLocale);
  }

  return null;
}

export default DevexInit;
